import React, { Component } from 'react';
import CarouselSlider from '../common/CarouselSlider';
import LoginHeader from '../common/LoginHeader';
import Button from '../common/Button';
import TextInput from '../common/TextInput';
import AlertDismissable from '../common/AlertDismissable';
import Upload from '../common/Upload';
import { has, map, each } from 'lodash';
import CustomScroll from 'react-custom-scroll';
import { validateFormSubmit } from '../../helpers';
import { validationMessage, imageBasePath, appBasePath } from '../../constants/staticData';
import ToastMessage from '../common/ToastMessage';

export default class BusinessDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submissionError: false,
      termsAgreed: true,
      uploadImgSize: 0,
      uploadImageErrText: false,
      imageUploaded: [],
      isButtonLoading: false
    };
    this.initialFormData = {
      companyname: '',
      addressline1: '',
      addressline2: '',
      addressline3: '',
      companyregistrationnumber: '',
      tradecopy: []
    };
    this.formData = {
      ...this.initialFormData
    };
    this.errors = {
      companyname: false,
      addressline1: false,
      tradecopy: false,
      companyregistrationnumber: false
    };
  }
  fileNameUpload(e) {
    let files = [], fileBlob = [], fileImgSize = 0, errFileType = false;
    this.setState({ uploadImageErrText: false });
    each(e.target.files, val => {
      files.push({ name: val.name, path: URL.createObjectURL(val), size: val.size });
      fileBlob.push(val);
      fileImgSize += val.size;
      if (val.type == 'image/png' || val.type == 'image/jpeg' || val.type == 'application/pdf') {
        errFileType = false;
      } else {
        errFileType = true;
      }
    });
    if (this.state.uploadImgSize + fileImgSize >= 25000000 || errFileType == true) {
      this.setState({ uploadImageErrText: true });
    } else {
      this.setState({
        imageUploaded: files,
        uploadImgSize: fileImgSize + this.state.uploadImgSize
      });
      this.formData['tradecopy'] = fileBlob;
      this.errors['tradecopy'] = false;
    }
    e.target.value = null;
  }
  cancelImageUpload(val) {
    let deleteSize = 0;
    if (this.state.uploadImgSize >= 25000000) {
      this.setState({ uploadImageErrText: true });
    } else {
      this.setState({ uploadImageErrText: false });
    }

    const array = this.state.imageUploaded;
    deleteSize = this.state.uploadImgSize - this.state.imageUploaded[val].size;
    array.splice(val, 1);
    this.setState({ imageUploaded: array, uploadImgSize: deleteSize });
    this.formData['tradecopy'] = array;
    this.errors['tradecopy'] = true;
  }
  onFieldBlur(value, name, validateError) {
    this.formData[name] = value;
    if (has(this.errors, name)) {
      this.errors[name] = validateError;
    }
  }
  completeSignup(e) {
    e.preventDefault();
    const { router } = this.props;
    let formData = {
      ...this.formData
    };
    if (!formData['tradecopy'].length) {
      this.errors['tradecopy'] = true;
    }
    const validatedForm = validateFormSubmit(formData, this.errors);
    this.errors = validatedForm.errors;
    if (!validatedForm.validForm) {
      this.setState({ submissionError: true });
      return;
    } else {
      this.setState({ submissionError: false, isButtonLoading: true });

      // S3 Flow
      let that = this;
      this.props.actions.getSignedURL(
        this.formData.tradecopy[0],
        'tradelicense',
        false,
        data => {
          if (data) {
            that.props.actions.uploadImage(
              this.formData.tradecopy[0],
              data.signed_request,
              data.url,
              data.imageId,
              false,
              () => {
                that.props.actions.registerBusinessProfile({
                  companyname: that.formData.companyname,
                  addressline1: that.formData.addressline1,
                  addressline2: that.formData.addressline2,
                  addressline3: that.formData.addressline3,
                  companyregistrationnumber: that.formData.companyregistrationnumber,
                  tradecopy: data.url,
                  profile_photo: data.url
                });
              },
              errMessage => {
                that.props.actions.showToastMessage(
                  errMessage ? errMessage : 'Problem uploading Trade copy. Try Again',
                  'error'
                );
              }
            );
          }
        },
        errMessage => {
          that.props.actions.showToastMessage(
            errMessage ? errMessage : 'Problem uploading Trade copy. Try Again',
            'error'
          );
        },
        false
      );
      // S3 Flow
    }
  }
  componentWillMount() {
    this.props.actions.clearComponentKey();
    const authData = localStorage.businessAuthData ? JSON.parse(localStorage.businessAuthData) : '';
    const userId = localStorage.getItem('businessUserId');
    if (userId && authData && authData.phone && authData.phoneVerified && authData.isBusinessRegistered) {
      if (authData.isGarageProfileCompleted && authData.isGarageServiceSelected) {
        this.props.router.push(`${appBasePath}/overview`);
      } else if (authData.isGarageProfileCompleted && !authData.isGarageServiceSelected) {
        this.props.router.push(`${appBasePath}/vendor-profile/manage-services`);
      } else {
        this.props.router.push(`${appBasePath}/vendor-profile/manage-profile`);
      }
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.authReducer.hideButtonLoader && this.state.isButtonLoading) {
      this.setState({ isButtonLoading: false });
    }
  }
  componentWillUnmount() {
    this.props.actions.hideErrorMessage();
  }
  render() {
    const imageUploadedView = map(this.state.imageUploaded, (img, index) => {
      return (
        <div className="upload-box-wrapper box-shadow" key={index}>
          <span
            className="cancel-image"
            onClick={() => {
              this.cancelImageUpload(index);
            }}
          >
            <i className="mdi mdi-close" />
          </span>
          <img
            src={
              img.name && img.name.split('.') && img.name.split('.').pop().toLowerCase() == 'pdf'
                ? `${imageBasePath}/pdf.png`
                : img.path
            }
          />
        </div>
      );
    });
    const { authReducer, commonReducer, actions } = this.props;
    return (
      <div className="container-fluid" id="wrapper">
        <LoginHeader actions={this.props.actions} router={this.props.router} />
        <CarouselSlider pageType="signUp" altTag="Business sign up carcility" sliderImage={`${imageBasePath}/business-sign-up-carcility.png`} />
        <div className="col-md-6 col-sm-12 col-xs-12 pad0 grid-12">
          <div className="customScroll">
            <CustomScroll heightRelativeToParent="calc(100%)" allowOuterScroll={true}>
              <div className="login-panel signup">
                <div className="login-panel-header">
                  <h3 className="login-title">Business Details</h3>
                  <p className="login-desc">Kindly fill in the detials below to continue to your Carcility profile.</p>
                </div>
                <div className="login-panel-body">
                  {authReducer &&
                    authReducer.showErrorMessage &&
                    <AlertDismissable
                      bsStyle="danger"
                      closeLabel="Close alert"
                      closeAction={this.props.actions.hideErrorMessage}
                    >
                      <p> <i className="mdi mdi-block-helper" /> {authReducer.statusMessage} </p>
                    </AlertDismissable>}
                  <TextInput
                    type="text"
                    label="Company Name"
                    name="companyname"
                    validationError={'Company Name'}
                    showValidationError={this.errors['companyname']}
                    validationError="Enter your Company Name"
                    emptyError={validationMessage.company.emptyError}
                    validationError={validationMessage.company.validationError}
                    onBlur={this.onFieldBlur.bind(this)}
                  />
                  <TextInput
                    type="text"
                    label="Address line 1"
                    name="addressline1"
                    validationError="Please enter Address line 1"
                    showValidationError={this.errors['addressline1']}
                    emptyError={validationMessage.address.emptyError}
                    validationError={validationMessage.address.validationError}
                    onBlur={this.onFieldBlur.bind(this)}
                  />
                  <TextInput
                    type="text"
                    label="Address line 2"
                    name="addressline2"
                    onBlur={this.onFieldBlur.bind(this)}
                  />
                  <TextInput
                    type="text"
                    label="Address line 3"
                    name="addressline3"
                    onBlur={this.onFieldBlur.bind(this)}
                  />
                  <TextInput
                    type="text"
                    label="Company Registration Number"
                    name="companyregistrationnumber"
                    showValidationError={this.errors['companyregistrationnumber']}
                    emptyError={validationMessage.companyregistrationnumber.emptyError}
                    validationError={validationMessage.companyregistrationnumber.validationError}
                    onBlur={this.onFieldBlur.bind(this)}
                  />
                </div>
                <div className="uploadCopy">
                  <label>
                    Upload Trade License Copy
                  </label>
                  <div className="upload-section">
                    <div className="row upload-image car-repair">
                      <div className="img-uploads licence-upload">
                        {this.state.imageUploaded && !this.state.imageUploaded.length
                          ? <Upload id="carProfileUpload" fileUpload={e => this.fileNameUpload(e)} />
                          : ''}
                        {imageUploadedView}
                      </div>
                      <span
                        className={
                          this.state.uploadImageErrText ? 'image-upload-error' : 'image-upload-error padLeft15 hide'
                        }
                      >
                        <p>
                          Sorry, your file size should be less than 25 MB and format should be JPG, PNG or PDF.
                          Try again with another file.
                        </p>
                        <i className="mdi mdi-close" onClick={() => this.setState({ uploadImageErrText: false })} />
                      </span>
                      {!this.state.uploadImageErrText &&
                        this.errors['tradecopy'] &&
                        <span className="image-upload-error">
                          <p>Please Upload the trade license copy.</p>
                        </span>}
                    </div>
                  </div>
                  <span className="upload-notes">The file has to be below 25 MB. Please use JPG, PNG or PDF.</span>
                </div>
                <div className="login-panel-footer">
                  <Button
                    dataLabelledby="Complete Sign Up"
                    btnCallBack={this.completeSignup.bind(this)}
                    isSubmitBtn={true}
                    btnType="red"
                    btnSize="lg"
                    fontSize={15}
                    label="Complete Sign Up"
                    isButtonLoading={this.state.isButtonLoading}
                  />
                </div>
              </div>
            </CustomScroll>
            {commonReducer.toastMessage &&
              <ToastMessage
                actions={actions}
                type={commonReducer.toastType}
                title={commonReducer.toastType + '...'}
                text={commonReducer.toastMessage}
              />}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Auth/BusinessDetail.jsx